const CUSTOMER_NOTE_TIME_ZONE = 'America/New_York';

function createCustomerNoteDraft(note, username, date = new Date()) {
    const formattedDate = new Intl.DateTimeFormat('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: '2-digit',
        timeZone: CUSTOMER_NOTE_TIME_ZONE,
    }).format(date);
    const attribution = ` - ${formattedDate} - ${username}`;
    const existingNote = note ? `${note}\n` : '';

    return {
        attribution,
        cursorPosition: existingNote.length,
        value: `${existingNote}${attribution}`,
    };
}

function adjustCustomerNoteEntryStart(previousDraft, nextDraft, entryStart) {
    let changeStart = 0;
    const shortestDraftLength = Math.min(previousDraft.length, nextDraft.length);
    while (
        changeStart < shortestDraftLength
        && previousDraft[changeStart] === nextDraft[changeStart]
    ) {
        changeStart++;
    }

    let previousChangeEnd = previousDraft.length;
    let nextChangeEnd = nextDraft.length;
    while (
        previousChangeEnd > changeStart
        && nextChangeEnd > changeStart
        && previousDraft[previousChangeEnd - 1] === nextDraft[nextChangeEnd - 1]
    ) {
        previousChangeEnd--;
        nextChangeEnd--;
    }

    if (changeStart >= entryStart) {
        return entryStart;
    }

    if (previousChangeEnd <= entryStart) {
        return entryStart + (nextChangeEnd - previousChangeEnd);
    }

    // A replacement crossed the entry boundary, so treat the replacement as part of the edited note history.
    return nextChangeEnd;
}

function finalizeCustomerNoteDraft(draft, attribution, entryStart) {
    if (!attribution) {
        return draft;
    }

    const attributionIndex = draft.lastIndexOf(attribution);
    if (
        attributionIndex < entryStart
        || draft.slice(entryStart, attributionIndex).trim()
        || draft.slice(attributionIndex + attribution.length).trim()
    ) {
        return draft;
    }

    return draft.slice(0, entryStart).replace(/\r?\n$/, '');
}

export {adjustCustomerNoteEntryStart, createCustomerNoteDraft, finalizeCustomerNoteDraft};
